import { useEffect, useState, useRef, useCallback } from 'react'
import { useInterval } from './useInterval'
import { useVisibilityChange } from './useVisibilityChange'

export const usePolling = (pollFn, options = {}) => {
  const { interval = 5000, onError } = options

  const [isPolling, setIsPolling] = useState(true)
  const [error, setError] = useState(null)

  const isPageVisible = useVisibilityChange()
  const pollFnRef = useRef(pollFn)
  const onErrorRef = useRef(onError)

  useEffect(() => {
    pollFnRef.current = pollFn
  }, [pollFn])

  useEffect(() => {
    onErrorRef.current = onError
  }, [onError])

  const executePoll = useCallback(async () => {
    if (!pollFnRef.current) return

    try {
      setError(null)
      await pollFnRef.current()
    } catch (err) {
      const errorToSet = err instanceof Error ? err : new Error(String(err))
      setError(errorToSet)

      if (onErrorRef.current) {
        onErrorRef.current(errorToSet)
      }
    }
  }, [])

  useEffect(() => {
    executePoll()
  }, [executePoll])

  const actualInterval = isPageVisible && isPolling ? interval : null

  useInterval(executePoll, actualInterval)

  const startPolling = useCallback(() => {
    setIsPolling(true)
    executePoll()
  }, [executePoll])

  const stopPolling = useCallback(() => {
    setIsPolling(false)
  }, [])

  return {
    isPolling: isPolling && isPageVisible,
    error,
    startPolling,
    stopPolling
  }
}
